export default "__VITE_ASSET__DaH25UqX__"